webpackJsonp([70],{

/***/ 1290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList__);




var changePage = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(value) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.page = value;
						this.loadData();

					case 2:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function changePage(_x) {
		return _ref.apply(this, arguments);
	};
}();

var changeState = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3) {
		var id = _ref3.id;
		var modelRow;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						modelRow = this.rows.filter(function (row) {
							return row.id === id;
						})[0];
						_context2.next = 3;
						return this.$http.patch('//products.japisale.com' + '/p/products/' + id + '/flag-active', { flagActive: modelRow.flagActive });

					case 3:
						this.loadData();

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function changeState(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var deleteRow = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
		var id = _ref6.id;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return this.$http.delete('//products.japisale.com' + '/p/products/' + id);

					case 2:
						this.showNotification('La prenda se eliminó correctamente', 'success');
						this.loadData();

					case 4:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function deleteRow(_x3) {
		return _ref5.apply(this, arguments);
	};
}();

var deleteRows = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(rows) {
		var ids, model;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						ids = rows.map(function (row) {
							return row.id;
						});
						model = {
							ids: ids
						};
						_context4.next = 4;
						return this.$http.delete('//products.japisale.com' + '/p/products', { body: model });

					case 4:
						this.showNotification('Las prendas se eliminaron correctamente', 'success');
						this.loadData();

					case 6:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function deleteRows(_x4) {
		return _ref7.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var parameters, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						parameters = {
							page: this.page,
							limit: this.limit
						};

						if (this.flagActive || this.flagActive === 0) {
							parameters.flagActive = this.flagActive;
						}
						if (this.search) {
							parameters.search = this.search;
						}
						if (this.sortField) {
							parameters.sortField = this.sortField;
						}
						if (this.sortDirection) {
							parameters.sortDirection = this.sortDirection;
						}
						_context5.next = 7;
						return this.$http.get('//products.japisale.com' + '/p/products/laundry', { params: parameters });

					case 7:
						response = _context5.sent;

						this.totalPages = Number(response.headers.get('x-last-page'));
						this.rows = response.data;
						this.loading = false;

					case 11:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function loadData() {
		return _ref9.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function created() {
	this.loadData();
}

function columnSortableEvent(_ref4) {
	var id = _ref4.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.sortField = newColumn[0].code;
	this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

function exportToExcel(rows) {
	var fieldNames = this.columns.map(function (column) {
		return column.name;
	});
	var columns = this.columns.map(function (column) {
		return column.code;
	});
	this.exportToCSV(fieldNames, columns, rows, 'Listado de prendas');
}

function goToEdit(_ref8) {
	var id = _ref8.id;

	var editHref = { name: 'config-laundry', params: { laundryId: id } };
	this.$router.push(editHref);
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	this.search = search;
	this.page = 1;
	this.loadData();
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id === 2) {
		this.flagActive = 1;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else if (filter.id === 3) {
		this.flagActive = 0;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else {
		this.flagActive = null;
		this.loading = true;
		this.page = 1;
		this.loadData();
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate___default.a,
		FilterList: __WEBPACK_IMPORTED_MODULE_7__components_shared_FilterList___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	created: created,
	data: function data() {
		return {
			columns: [{ id: 1, name: 'Imagen', code: 'urlImage' }, { id: 2, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } }, { id: 3, name: 'Precio del Lavado', code: 'price', isSortable: { down: true, up: false } }],
			filterValue: 1,
			flagActive: null,
			href: { name: 'form-laundry' },
			limit: 10,
			loading: false,
			page: 1,
			rows: [],
			totalPages: 5,
			search: null,
			sortDirection: null,
			sortField: null
		};
	},

	filters: {
		round: __WEBPACK_IMPORTED_MODULE_4__shared_filters__["c" /* round */]
	},
	methods: {
		changePage: changePage,
		changeState: changeState,
		columnSortableEvent: columnSortableEvent,
		deleteRow: deleteRow,
		deleteRows: deleteRows,
		exportToExcel: exportToExcel,
		goToEdit: goToEdit,
		loadData: loadData,
		searchByColumn: searchByColumn,
		selectedFilter: selectedFilter
	},
	mixins: __WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* default */],
	name: 'laundry'
});

/***/ }),

/***/ 1438:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".image-column[data-v-e512891e]{height:52px!important;padding:5px 20px 5px 0!important;width:73px}.laundry-image[data-v-e512891e]{background-color:#fff;border:1px solid #dcdcdc;height:100%;padding:13px 20px}.laundry-image img[data-v-e512891e]{vertical-align:middle}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/laundry/List.vue"],"names":[],"mappings":"AACA,+BACE,sBAAwB,AACxB,iCAAqC,AACrC,UAAY,CACb,AACD,gCACE,sBAAwB,AACxB,yBAA0B,AAC1B,YAAa,AACb,iBAAmB,CACpB,AACD,oCACI,qBAAuB,CAC1B","file":"List.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.image-column[data-v-e512891e] {\n  height: 52px !important;\n  padding: 5px 20px 5px 0px !important;\n  width: 73px;\n}\n.laundry-image[data-v-e512891e] {\n  background-color: white;\n  border: solid 1px #dcdcdc;\n  height: 100%;\n  padding: 13px 20px;\n}\n.laundry-image img[data-v-e512891e] {\n    vertical-align: middle;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1523:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1438);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("e1f4c544", content, true);

/***/ }),

/***/ 1695:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "laundry"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "md10": "",
      "pl-1": ""
    }
  }, [_c('div', {
    staticClass: "inline-filter-list"
  }, [_c('filter-list', {
    attrs: {
      "value": _vm.filterValue
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": 'Prenda',
      "href": _vm.href
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": true,
      "include-export-to-excel": true,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "include-delete-single": true,
      "switch-value": 'flagActive'
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "on-change-state": _vm.changeState,
      "on-delete-event": _vm.deleteRow,
      "on-delete-selected": _vm.deleteRows,
      "on-export-selected": _vm.exportToExcel,
      "go-to-edit-page": _vm.goToEdit
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', {
          staticClass: "image-column"
        }, [_c('div', {
          staticClass: "laundry-image"
        }, [_c('img', {
          attrs: {
            "src": props.row.urlImage,
            "alt": props.row.name,
            "width": "28",
            "height": "26"
          }
        })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(props.row.price)))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages),
      expression: "totalPages"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1523)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1290),
  /* template */
  __webpack_require__(1695),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e512891e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/70.6480e35a1d1146da4361.js